import React from 'react';
import RegistrationTestimonials from '../../containers/registration/RegistrationTestimonials';
import compDetails from '../../assets/img/comp-details.png';
import candiDetails from '../../assets/img/Candidate-ver.svg';

type Props = {
    isCompany?: boolean;
    showTestimonial?: boolean;
    signAs: string;
    columnSize?: number;
};

const LeftPanelContent: React.FC<Props> = ({ isCompany = false, showTestimonial, signAs, columnSize = 7 }) => {
    return (
        <>
            {showTestimonial ? (
                <div className="col-lg-7 order-lg-1 order-md-1 order-2 mobile-hide">
                    <RegistrationTestimonials />
                </div>
            ) : signAs === 'company' ? (
                <div className="col-lg-7 col-md-12 col-12 d-flex justify-content-center align-items-center">
                    <div>
                        <img src={compDetails} className="mobile-hide mt-5 img-fluid" alt="" />
                    </div>
                </div>
            ) : (
                <div
                    className={`col-lg-${columnSize} col-md-12 col-12 d-flex justify-content-center align-items-center`}
                >
                    <div>
                        <div>
                            <img src={candiDetails} className="mobile-hide mt-5 img-fluid" alt="" />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LeftPanelContent;
